<template>
  <v-navigation-drawer id="app-navgation" color="blue-grey darken-4"
    class="grey lighten-4" v-model="showMenu" clipped fixed app
    :mini-variant="menuSmall && $vuetify.breakpoint.mdAndUp"
    :permanent="$vuetify.breakpoint.mdAndUp"
    v-if="currentUser && currentUser.logged">
    <v-list>
      <v-list-tile v-for="(item, index) in items"
        :key="index" @click="go(item)" :disabled="item.disabled">
        <v-list-tile-action>
          <v-tooltip right>
            <v-icon slot="activator">{{ 'fal fa-' + item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </v-tooltip>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import router from '@/router'
import EventBus from '@/event-bus'

export default {
  data: () => ({
    items: [],
    showMenu: false,
    menuSmall: true,
    currentUserIsAdmin: false
  }),

  methods: {
    checkCurrentUser () {
      this.currentUserIsAdmin = false
      let currentUser

      if (localStorage.getItem('currentUser')) {
        currentUser = JSON.parse(localStorage.getItem('currentUser'))

        if (currentUser.roles) {
          this.currentUserIsAdmin = currentUser.roles.indexOf('admin') !== -1
        }
      }
    },

    go (item) {
      router.push({ name: item.routerName })
    },

    async menuItems () {
      await this.checkCurrentUser()

      if (this.currentUserIsAdmin) {
        this.items = [
          { icon: 'tachometer', title: 'Início', routerName: 'AdminOverview' },
          { icon: 'users', title: 'Alunos', routerName: 'AdminUsers' },
          { icon: 'stopwatch', title: 'Exercícios', routerName: 'AdminExercises' },
          { icon: 'dumbbell', title: 'Treinos', routerName: 'AdminTrainings' },
          { icon: 'calendar-alt', title: 'Agenda', routerName: 'AdminCalendar' },
          { icon: 'bell', title: 'Notificações', routerName: 'AdminNotifications' },
          { icon: 'usd-circle', title: 'Financeiro', routerName: 'AdminFinancial' },
          { icon: 'headset', title: 'Suporte', routerName: 'AdminSupport' }
        ]
      } else {
        this.items = [
          { icon: 'tachometer', title: 'Início', routerName: 'UserOverview' },
          { icon: 'dumbbell', title: 'Treinos', routerName: 'UserTrainings' },
          { icon: 'ruler-combined', title: 'Avaliações', routerName: 'UserEvaluations' },
          { icon: 'headset', title: 'Suporte', routerName: 'UserSupport' },
          { icon: 'usd-circle', title: 'Financeiro', routerName: 'UserFinancial' }
        ]
      }
    }
  },

  mounted () {
    this.menuItems()

    EventBus.$on('showMenu', data => {
      this.showMenu = data
    })

    EventBus.$on('menuSmall', data => {
      this.menuSmall = data
    })
  },

  watch: {
    '$route': 'menuItems'
  },

  props: {
    currentUser: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/AppNavigation.vue